<template>
<div class="follow-page">
    <img src="@/assets/WechatIMG472.jpg" v-if="!this.isImage" class="img-page" alt="">
    <img src="@/assets/WechatIMG475.jpg" v-else class="img-page" alt="">
    <div class="page-txt">长按二维码关注公众号</div>
</div>
</template>
<script>
export default {
  data() {
    return {
      isImage: false
    }
  },
  mounted() {
    this.isImage = window.location.href.indexOf('https://iep.jjmc.cn') > -1
  }
}
</script>
<style lang="less" scoped>
.follow-page {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    flex-wrap: wrap;
    .img-page {
        width: 250px;
        display: block;
    }
    .page-txt {
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/followPage.vue